<template>
    <el-dialog class="app-dialog"
               :class="minWidthSet ? 'app-dialog_width' : ''"
               :title="title"
               :width="width"
               :custom-class="customClass"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :append-to-body="true"
               @close="handleCancel">
        <template slot="title">
            <slot name="title"><span class="el-dialog-title">{{title}}</span></slot>
        </template>
        <div class="app-dialog_content">
            <slot></slot>
        </div>
        <div slot="footer" class="dialog-footer" v-if="needFooter">
            <slot name="footer">
                <el-button v-if="cancelText" class="button-height" @click="handleCancel">{{cancelText}}</el-button>
                <el-button class="button-height" type="primary" @click="handleSubmit">{{submitText}}</el-button>
            </slot>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'app-dialog',
    props: {
        title: {
            type: String,
            default: '标题'
        },
        needFooter: {
            type: Boolean,
            default: true
        },
        submitText: {
            type: String,
            default: '确 定'
        },
        cancelText: {
            type: String,
            default: '取 消'
        },
        customClass: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            dialogVisible: true,
            minWidthSet: true
        };
    },
    created () {
        if (this.width) {
            this.minWidthSet = false;
        }
    },
    methods: {
        handleCancel () {
            this.$emit('onCancel');
        },
        handleSubmit () {
            this.$emit('onSubmit');
        }
    }
};
</script>

<style scoped lang="scss">
.app-dialog_width {
    ::v-deep {
        .el-dialog {
            width: auto;
            min-width: 640px;
        }
    }
}
.app-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
    ::v-deep {
        .el-dialog {
            margin: unset!important;
            overflow: hidden;
            .el-dialog__header {
                padding: 16px 24px;
                height: 56px;
                border-bottom: 1px solid rgba(0,0,0,0.09);
                box-sizing: border-box;
                .el-dialog__title, .el-dialog-title {
                    color: rgba(0,0,0,0.85);
                }
            }
            .el-dialog__body {
                padding: unset;
                height: calc(100% - 56px);
                overflow: hidden;
                .app-dialog_content {
                    overflow: hidden;
                    height: 100%;
                    .app-pagination-layout {
                        padding: unset;
                    }
                }
            }
            .el-dialog__footer {
                height: 52px;
                border-top: 1px solid rgba(0,0,0,0.09);
            }
        }
    }
    .app-dialog_content {
        padding: 24px 48px;
    }
}
</style>
